module.exports = __webpack_public_path__ + "img/step3-detail_bottoom1.04a8b154.png";